export const rdl = {
  logo_image_url: 'rdl.png',
  logo_height: 150,
  token_hidden: true,
  button_color: 'black',
  button_outlined_as_default: true,
  text_font: `'Open Sans', sans-serif`,
  title_font: `'Open Sans', sans-serif`,
  button_text_uppercase: true,
}

export const rdl_culture = {
  ...rdl,
  token_url: 'rdl/culture.png',
  token_hidden: false,
  number_hidden: true,
  button_color: '#e5564f',
}

export const rdl_fantome_1 = {
  ...rdl,
  token_url: 'rdl/fantome1.png',
  token_hidden: false,
  number_hidden: true,
}

export const rdl_fantome_2 = {
  ...rdl,
  token_url: 'rdl/fantome2.png',
  token_hidden: false,
  number_hidden: true,
}

export const rdl_fantome_3 = {
  ...rdl,
  token_url: 'rdl/fantome3.png',
  token_hidden: false,
  number_hidden: true,
}

export const rdl_fantome_4 = {
  ...rdl,
  token_url: 'rdl/fantome4.png',
  token_hidden: false,
  number_hidden: true,
}

export const rdl_fantome_5 = {
  ...rdl,
  token_url: 'rdl/fantome5.png',
  token_hidden: false,
  number_hidden: true,
}

export const rdl_fantome_6 = {
  ...rdl,
  token_url: 'rdl/fantome6.png',
  token_hidden: false,
  number_hidden: true,
}

export const rdl_fantome_7 = {
  ...rdl,
  token_url: 'rdl/fantome7.png',
  token_hidden: false,
  number_hidden: true,
}

export const rdl_fantome_8 = {
  ...rdl,
  token_url: 'rdl/fantome8.png',
  token_hidden: false,
  number_hidden: true,
}

export const rdl_fleuve = {
  ...rdl,
  token_url: 'rdl/fleuve.png',
  token_hidden: false,
  number_hidden: true,
  button_color: '#169cb5',
}

export const rdl_nature = {
  ...rdl,
  token_url: 'rdl/nature.png',
  token_hidden: false,
  number_hidden: true,
  button_color: '#f59b25',
}

export const rdl_quartier = {
  ...rdl,
  token_hidden: false,
  button_color: '#e5554f',
}

export const rdl_jdq_vasque = {
  ...rdl,
  token_url: 'rdl/jdq_vasque.png',
  token_hidden: false,
  number_hidden: true,
}

export const rdl_jdq_citedesjeunes = {
  ...rdl,
  token_url: 'rdl/jdq_citedesjeunes.png',
  token_hidden: false,
  number_hidden: true,
}

export const rdl_jdq_piloup = {
  ...rdl,
  token_url: 'rdl/jdq_piloup.png',
  token_hidden: false,
  number_hidden: true,
}

export const rdl_jdq_piscine = {
  ...rdl,
  token_url: 'rdl/jdq_piscine.png',
  token_hidden: false,
  number_hidden: true,
}

export const rdl_jdq_piste = {
  ...rdl,
  token_url: 'rdl/jdq_piste.png',
  token_hidden: false,
  number_hidden: true,
}

export const rdl_jdq_residences = {
  ...rdl,
  token_url: 'rdl/jdq_residences.png',
  token_hidden: false,
  number_hidden: true,
}
